import { ThemeConfig } from 'antd';

import { colors } from './colors';

export const antdTheme: ThemeConfig = {
  token: {
    fontFamily: 'Satoshi, -apple-system, BlinkMacSystemFont, sans-serif',
    colorPrimary: colors.primary,
    colorPrimaryHover: colors.primaryHover,
    colorPrimaryActive: colors.primaryActive,
    borderRadius: 10,
  },
  components: {
    // Білий фон усіх Layout (хедер і область під контентом), без сірого
    // colorBgLayout, що проглядав під таблицею при скролі.
    Layout: {
      bodyBg: '#ffffff',
    },
  },
};
